/* import __COLOCATED_TEMPLATE__ from './configure-emails.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { isBlank } from '@ember/utils';

interface Signature {
  Args: {
    onNext?: () => void;
    openSection: string | null;
    setSection?: (section: string | null) => void;
  };
}

export default class ConfigureEmailsComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get salesforceConfig() {
    return this.finStandaloneService.salesforceConfig;
  }

  @action
  setSection(section: string | null) {
    this.args.setSection?.(section);
  }

  get openSection() {
    if (
      !this.salesforceConfig?.isConnected ||
      (this.args.openSection === 'verify-email-domain' &&
        isBlank(this.salesforceConfig?.supportEmail))
    ) {
      return null;
    }

    return this.args.openSection;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::ConfigureEmails': typeof ConfigureEmailsComponent;
  }
}
